import React from "react";
import styled from "styled-components";
import ContextMenu from "./context-menu";

const Container = styled.div`
  background: rgba(255, 255, 255, 0.3);
  flex-grow: 1;
  display: flex;
  height: 100%;
  align-items: center;
`;

const CanvasWrapper = styled.div`
  max-width: 512px;
  margin: 0 auto;
  background-color: #fff;
  /* background-image: linear-gradient(45deg, #ccc 25%, transparent 25%),
    linear-gradient(-45deg, #ccc 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #ccc 75%),
    linear-gradient(-45deg, transparent 75%, #ccc 75%); */
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
`;

function Canvas({
  canvasRef,
  contextMenu,
  contextMenuPosition,
  contextMenuClose,
  selectAll,
  deleteSelected,
  deleteAll,
  bringToFront,
  sendToBack
}) {
  return (
    <Container>
      <CanvasWrapper>
        <canvas ref={canvasRef} />
        <ContextMenu
          contextMenu={contextMenu}
          contextMenuPosition={contextMenuPosition}
          contextMenuClose={contextMenuClose}
          selectAll={selectAll}
          deleteSelected={deleteSelected}
          deleteAll={deleteAll}
          bringToFront={bringToFront}
          sendToBack={sendToBack}
        />
      </CanvasWrapper>
    </Container>
  );
}

export default Canvas;
